import { gql } from '@apollo/client'
import { useDocument, useQueryEffect } from '@ztechapps/common.hook'
import type { Chat, ChatMessage } from '@ztechapps/common.contract'
import type { Dispatch, SetStateAction } from 'react'
import React from 'react'
import orderBy from 'lodash/orderBy'

export const chatMessagesQuery = gql`
  query allChat($filter: JSON!, $options: JSON) {
    allChat(filter: $filter, options: $options) {
      _id
      code
      subject
      externalId
      messages {
        _id
        content
        isPublic
        timeStamp
        sender {
          _id
          profile {
            _id
            name
            email
            picture
          }
        }
        attachments {
          _id
          uri
          name
          mimetype
          encoding
          description
          isInline
        }
      }
    }
  }
`

export type UseChatMessagesResult = {
  loading: boolean
  error: Error
  messages: ChatMessage[]
  setMessages: Dispatch<SetStateAction<ChatMessage[]>>
  document: Chat
  onRefresh: () => Promise<void>
}
export type UseChatMessagesProps = {
  conversationId: string
}

export const useChatMessage = ({ conversationId }: UseChatMessagesProps): UseChatMessagesResult => {
  const documentResult = useDocument<Chat>({
    query: chatMessagesQuery,
    filter: { externalId: conversationId ?? null },
    //options: { queryOptions: { skip: !conversationId } },
  })

  const { document, loading, error, refetch } = documentResult
  const [messages, setMessages] = React.useState<ChatMessage[]>([])

  useQueryEffect(() => {
    if (documentResult.loading) return
    const _messages = document?.messages
    const sortedMessages = orderBy(_messages, ['timeStamp'], ['desc'])
    setMessages(sortedMessages)
  }, documentResult)

  return {
    loading,
    error,
    messages,
    setMessages,
    document,
    onRefresh: () => refetch(),
  }
}
